// @ts-nocheck
/* global css */
import React, { useState, useEffect } from 'react';
import { cssInJS } from '../../utils/styles';
import THEME from '../../shared/theme';

interface Props {
  value: string,
  part: string,
  placeholder: string,
  disabled?: boolean,
  onChange?: (part: string, newVal: string) => void,
}

/**
 * @deprecated this file has been replaced by material
 */
const AddressPart: React.FC<Props> = ({
  value,
  part,
  placeholder,
  disabled = false,
  onChange,
}: Props) => {
  const [inpValue, setValue] = useState(value || '');
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setValue(newValue);
    if (onChange) {
      onChange(part, newValue);
    }
  };
  useEffect(() => {
    setValue(value || '');
  }, [value]);
  return (
    <div>
      <input
        type="text"
        key={part}
        className={css(part, styles.input)}
        placeholder={placeholder}
        disabled={disabled}
        value={inpValue}
        onChange={handleChange}
      />
    </div>
  );
};

const styles = cssInJS({
  input: {
    marginTop: 4,
    border: '1px solid #d9d9d9',
    padding: 4,
    width: '100%',
    borderRadius: 5,
    fontSize: THEME.editFontSize,
    fontFamily: THEME.fontFamily,

    '@phone': {
      border: 'none',
      padding: 6,
    },
  },
});

export default AddressPart;
